// resources/js/woocommerce/mini-cart/ajax-add-to-cart.js
import { openPanel } from './panel.js';

function wcAjaxURL(endpoint) {
  const p = window.wc_add_to_cart_params?.wc_ajax_url;
  if (p) return p.replace('%%endpoint%%', endpoint);
  const base = window.wc_ajax_url || '/?wc-ajax=%%endpoint%%';
  return base.replace('%%endpoint%%', endpoint);
}

async function ajaxAddToCartFromForm(form, btn) {
  if (!form || !form.classList.contains('variations_form')) return false;

  const vidEl = form.querySelector('input.variation_id');
  if (!vidEl || !vidEl.value) return false;

  if (form.dataset.wkAjaxing === '1') return true; // voorkom dubbel
  form.dataset.wkAjaxing = '1';
  if (btn) btn.disabled = true;

  const fd = new FormData(form);
  const body = new URLSearchParams();
  fd.forEach((v, k) => {
    if (String(k).startsWith('attribute_') && String(v).trim() === '') return;
    body.append(k, v);
  });

  try {
    const res  = await fetch(wcAjaxURL('add_to_cart'), {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
      body: body.toString()
    });
    const json = await res.json();

    if (json?.fragments) {
      if (window.jQuery) {
        jQuery(document.body).trigger('added_to_cart', [json.fragments, json.cart_hash, btn || form]);
        jQuery(document.body).trigger('wc_fragment_refresh');
      }
      openPanel();
      return true;
    }

    if (json?.error && json?.product_url) {
      window.location = json.product_url;
      return false;
    }
  } catch (err) {
    console.error('AJAX add_to_cart (variation) failed:', err);
  } finally {
    delete form.dataset.wkAjaxing;
    if (btn) btn.disabled = false;
  }

  return false;
}

export function initAjaxAddToCart() {
  // 1) Kliks op knoppen in variatieformulieren
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('form.variations_form.cart [data-card-submit], form.variations_form.cart .single_add_to_cart_button');
    if (!btn) return;

    const form = btn.closest('form.variations_form.cart');
    if (!form) return;

    const vid = form.querySelector('.variation_id');
    if (!vid || !vid.value) return;

    e.preventDefault();
    const ok = await ajaxAddToCartFromForm(form, btn);
    if (!ok) form.submit();
  });

  // 2) Native submit (ook zonder klik)
  document.addEventListener('submit', async (e) => {
    const form = e.target?.closest?.('form.variations_form.cart');
    if (!form) return;

    const vid = form.querySelector('.variation_id');
    if (!vid || !vid.value) return;

    e.preventDefault();
    const btn = form.querySelector('.single_add_to_cart_button, [data-card-submit]');
    const ok = await ajaxAddToCartFromForm(form, btn);
    if (!ok) form.submit();
  }, { capture: true });

  // 3) jQuery .trigger('submit')
  if (window.jQuery) {
    jQuery(document).on('submit', 'form.variations_form.cart', async function (e) {
      const form = this;
      const vid = form.querySelector('.variation_id');
      if (!vid || !vid.value) return;

      if (!e.isDefaultPrevented()) {
        e.preventDefault();
        const btn = form.querySelector('.single_add_to_cart_button, [data-card-submit]');
        const ok = await ajaxAddToCartFromForm(form, btn);
        if (!ok) form.submit();
      }
    });
  }
}
